export const cmsMenuProps = () => ({
  menu: {
    type: Array,
    required: true
  },
  hasLocationCora: {
    type: Boolean,
    required: false,
    default: false
  },
  webAlias: {
    type: String,
    required: false,
    default: null
  }
})

export const useCmsMenu = () => {
  const activeCategory = ref(null);
  const showCategory = (menuItem) => {
    activeCategory.value = menuItem;
  };
  const hide = () => {
    activeCategory.value = null;
  }

  return {
    activeCategory,
    showCategory,
    hide
  }
}